import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "modules/common/advance-table/AdvanceTablePagination";
import AdvanceTableSearchBox from "modules/common/advance-table/AdvanceTableSearchBox";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import moment from "moment";
import React from "react";
import { Col, Row } from "react-bootstrap";

function CommunityHistoryTable({ data }) {

  const columns = [
    {
      accessor: "first_name",
      Header: "Name",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "display_name",
      Header: "Tag",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "filename",
      Header: "File Name",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "users_added",
      Header: "Phone Number Count",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "successful",
      Header: "Successful",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "failed",
      Header: "Failed",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "reason",
      Header: "Reason",
      headerProps: { className: "text-900" },
    },
    {
        accessor: (row) => moment(row.created_at).format("YYYY-MM-DD"),
        Header: "Created At",
        headerProps: { className: "text-900" },
      },
  ];

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={10}
    >
      <Row className="flex-end-center mb-3">
        <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table />
        </Col>
      </Row>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
      <div className="mt-3">
        <AdvanceTablePagination table className="pagination-sm" />
      </div>
    </AdvanceTableWrapper>
  );
}

export default CommunityHistoryTable;
